<template>
	<div id="Updatepwd">
        <HrrBreadcrumb PMname="用户权限管理" CMname="修改密码" />
        <HrrMainCardLayout>
            <template slot="custom">
                <el-card class="card" style="margin-top:10px;" shadow="never">
                    <el-form  class="pwd pwd-el-form"  :rules="rules" ref="form" :model="form" label-width="120px">
                        <el-form-item label="旧密码：" prop="oriPwd" >
                            <el-input v-model="form.oriPwd" ></el-input>
                        </el-form-item>
                        <el-form-item label="新密码：" prop="pwd" >
                            <el-input v-model="form.pwd" type="password"></el-input>
                            <el-alert title="密码长度为8-20位,以数字和字母和特殊字符组成" show-icon type="warning" :closable="false"></el-alert>
                        </el-form-item>
                        <el-form-item label="重复新密码：" prop="confirmpwd" type="password">
                            <el-input v-model="form.confirmpwd" type="password"></el-input>
                            <el-alert title="请确保两次输入一致" show-icon type="warning" :closable="false"></el-alert>
                        </el-form-item>
                    </el-form>
                    <div>
                        <el-button type="primary" @click="submitForm('form')" >保 存</el-button>
                    </div>
                </el-card>
            </template>
        </HrrMainCardLayout>
	</div>
</template>
<script>
    export default{
        name:"Updatepwd",
        data(){
            var validatepwd = (rule, value, callback) => {
                if (value=='') {
                    callback(new Error('请输入新密码'));
                }else
                {
                    var reg=/^[a-zA-Z0-9-_\&\@\#\!\%\&]{8,20}$/;
                    if(reg.test(value)==false){
                        callback(new Error('密码格式不符合'));
                    }else{
                        if (this.rules.confirmpwd!='') {
                            this.$refs.form.validateField('confirmpwd');
                        }
                        callback();
                    }
                }
            };
            var validateConfirmpwd = (rule, value, callback) => {
                if (value=='') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.form.pwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return{
                form:{
                    oriPwd:"",
                    pwd:"",
                    confirmpwd:""
                },
                rules:{
                    oriPwd:[{required: true, message: '请输入旧密码', trigger: 'blur'}],
                    pwd:[{required: true, validator: validatepwd, trigger: 'blur'}],
					confirmpwd:[{required: true, validator: validateConfirmpwd, trigger: 'blur',}]
                }
            }
        },
        methods:{
            submitForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var loading = this.$loading({
                            lock: true,
                            text: '修改密码提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        var Vuethis=this;
                        this.$hrraxios.post(this.$api.system.changepwd, this.form)
                        .then((response)=>{
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("您的密码修改成功！",{callback:action=>{
                                    Vuethis.$refs["form"].resetFields();
                                    Vuethis.$emit("loginout");
                                }});
                            } else {
                                Vuethis.$message.error(data.Prompt);
                            }
                        })
                        .catch((error)=>{
                            loading.close();
                        });

                    }else{
                        return false;
                    }
                });
            },
        }
    }
</script>
<style>
.pwd-el-form{width:34%;}
#Updatepwd .el-alert--warning{position:absolute;right:-101%;top:-2px;padding:2px 4px;}
</style>